module.exports = __webpack_public_path__ + "img/network-config.a1d4e7c3.png";